import React from "react";
import Cell from "./Cell";

export default function Menu({ language, onlyOne }) {
  if (onlyOne)
    return (
      <div className="w-100">
        <Cell language={language} onlyOne={true} />
      </div>
    );
  return (
    <div className="w-100 pt-4">
      <Cell language={language} />
      <Cell language={language} />
      <Cell language={language} />
      <Cell language={language} />
    </div>
  );
}
